module.exports = __webpack_public_path__ + "files/70628c65ae7b0eb6c7ca4e2122a19883.png";